// extracted by mini-css-extract-plugin
module.exports = {"seoFaqBlock":"seoFaqBlock_seoFaqBlock__hDy3g","faq-nav":"seoFaqBlock_faq-nav__RDtBu","statues-table":"seoFaqBlock_statues-table__9l9RL"};